module.exports = __webpack_public_path__ + "media/group@3x.58b941c1.jpg";